'use client';

import React from 'react';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import {
    useWindowSize,
    isMobile,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Link from 'next/link';
import background from '@app/icons/academy/promotion_course.jpg';
import backgroundMobile from '@app/icons/academy/promotion_course_mobile.jpg';
import arrowIcon from '@app/icons/arrow--black.svg';
import Image from '@app/components/Image/Image';
import { IPromotionCourseApiModel } from '@app/models/features/course';
import HtmlMarkup from '@app/components/HtmlMarkup/HtmlMarkup';

import styles from './PromotionCourseSection.module.scss';

export interface IProps {
    /**
     * Текст кнопки
     */
    buttonText?: string;
    /**
     * Ссылка кнопки
     */
    buttonUrl?: string;
    /**
     * Информация о рекламном курсе
     */
    promotionCourse: IPromotionCourseApiModel;
    /**
     * Класс
     */
    classNames?: string;

}

/**
 * Компонент для отрисовки рекламного курса
 */
const PromotionCourseSection:React.FC<IProps> = props => {
    const {
        promotionCourse,
        classNames,
    } = props;
    const {
        buttonText = 'Учиться',
        buttonUrl = `/academy/courses/${promotionCourse?.slug}`,
    } = props;
    const { width: screenWidth } = useWindowSize();
    const isMobileScreen = isMobile(screenWidth);
    const containerBackground = isMobileScreen
        ? promotionCourse?.mobile_image_url ?? backgroundMobile
        : promotionCourse?.image_url ?? background;

    const containerClassName = mergeClassNames([
        styles['container'],
        classNames,
    ]);

    return (
        <div className={containerClassName} style={{ backgroundImage: `url(${getAssetSrc(containerBackground)})` }}>
            <div className={styles['info']}>
                <div className={styles['text']}>Начните сейчас</div>
                <HtmlMarkup tag="div" className={styles['title']} markup={promotionCourse?.title} />
                <div className={styles['link-wrapper']}>
                    <Link href={buttonUrl} className={styles['link']}>
                        <span>{buttonText}</span>
                        <Image src={arrowIcon} width={12} height={12} alt="" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PromotionCourseSection;